export const DEFAULT_STATE = null;

const lastUsedImageType = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case 'SAVE_SINGLE_SIGNATURE':
      return action.sigType;
    case 'UPDATE_REQUEST_SIGNATURE_CONTENT':
      return action.sigType || state;
    case 'REMOVE_SIGNATURE_SUCCESS':
      return action.sigType === state ? null : state;
    default:
      return state;
  }
};

export default lastUsedImageType;



// WEBPACK FOOTER //
// ./src-react/SignatureManager/SignatureReducer/lastUsedImageType.jsx